/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { prepareSend } from './platform';
export type { ExporterConfig } from './types';
export { ZipkinExporter } from './zipkin';
